module.exports = __webpack_public_path__ + "static/main4-f5675e3cbd19fc70709da5e733926589.png";